var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiciosIndustria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3249 16.9643C16.3249 17.4576 15.9596 17.8571 15.5087 17.8571H10.6112C10.1602 17.8571 9.79495 17.4576 9.79495 16.9643V14.2857H0V22.3214C0 23.75 1.14274 25 2.44874 25H23.6711C24.9771 25 26.1199 23.75 26.1199 22.3214V14.2857H16.3249V16.9643ZM23.6711 5.35714H19.5899V2.67857C19.5899 1.25 18.4472 0 17.1412 0H8.9787C7.67271 0 6.52997 1.25 6.52997 2.67857V5.35714H2.44874C1.14274 5.35714 0 6.60714 0 8.03571V12.5H26.1199V8.03571C26.1199 6.60714 24.9771 5.35714 23.6711 5.35714ZM16.3249 5.35714H9.79495V3.57143H16.3249V5.35714Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiciosIndustria);
export default __webpack_public_path__ + "static/media/servicios-industria.fa9db88a408617a199ea52767436edb9.svg";
export { ForwardRef as ReactComponent };